// extracted by mini-css-extract-plugin
export default {"cText":"Contact_cText__9T4B4","logoImg":"Contact_logoImg__zUMAH","cLink":"Contact_cLink__eaf2q","cTitle":"Contact_cTitle__e+DrM","com":"Contact_com__cJ35N"};